import PropTypes from 'prop-types'

import { ActivityIndicator } from '../../../../components'
import { Heading } from '../../../../components/ui/Heading'
import { useDiscover } from '../../hooks/useDiscover'

export default function NextStepsPromptMessage({
  title,
  primaryPrompt,
  primaryAction,
  primaryOnClick,
  secondaryOnClick,
  secondaryPrompt,
  secondaryAction
}) {
  const { isChancesAndRisksLoading } = useDiscover()

  return (
    <div className='w-full max-w-md rounded-lg border border-lightGrey bg-[#F7F9FE] p-4'>
      <Heading level={5}>{title}</Heading>
      <div className='mt-2'>
        <span className='block text-sm font-normal text-darkBlack'>
          {primaryPrompt}
        </span>
        <button
          onClick={primaryOnClick}
          disabled={isChancesAndRisksLoading}
          className='mt-1 text-sm font-medium text-buttonSecondaryBlue'
        >
          {isChancesAndRisksLoading ? (
            <ActivityIndicator className='flex' />
          ) : (
            primaryAction
          )}
        </button>
      </div>
      {/* <div className='mt-2'>
        <span className='block text-sm font-normal text-darkBlack'>
          {secondaryPrompt}
        </span>
        <button
          onClick={secondaryOnClick}
          disabled={customIsLoading}
          className='mt-1 text-sm font-medium text-buttonSecondaryBlue'
        >
          {customIsLoading ? (
            <ActivityIndicator color={'#4461D4'} />
          ) : (
            secondaryAction
          )}
        </button>
      </div> */}
    </div>
  )
}

NextStepsPromptMessage.propTypes = {
  title: PropTypes.string,
  primaryPrompt: PropTypes.string,
  secondaryPrompt: PropTypes.string,
  primaryAction: PropTypes.string,
  primaryOnClick: PropTypes.func.isRequired,
  secondaryAction: PropTypes.string,
  secondaryOnClick: PropTypes.func.isRequired
}
